import { request } from '../core';
export class RepairOrderFetchApi {
  /**
   * 1.1. 获取整车厂列表
   */
  static getOemList(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_oem_list',
      method: 'POST',
    };
    return request(requestOptions);
  }

  /**
   * 1.2. 获取服务站列表
   */
  static getServiceStationList(params: {
    oemId?: number;
    enable?: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_service_station_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.3. 获取各维修单状态统计
   */
  static getRequireStatusStatistic(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    oemId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_require_status_statistics',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.4. 分页获取待受理维修单列表
   */
  static getToDoAcceptRequirePageList(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    oemId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
    pageNum: number;
    pageSize: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_to_do_accept_require_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.5. 分页获取维修中列表
   */
  static getMaintainingRequirePageList(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    oemId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
    pageNum: number;
    pageSize: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_maintaining_require_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.6. 分页获取待验收列表
   */
  static getToDoCheckRequirePageList(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    oemId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
    pageNum: number;
    pageSize: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_to_do_check_require_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.7. 分页获取验收驳回列表
   */
  static getCheckRejectRequirePageList(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    oemId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
    pageNum: number;
    pageSize: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_check_reject_require_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.8. 分页获取已完成列表
   */
  static getCompletedRequirePageList(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    oemId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
    pageNum: number;
    pageSize: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_complete_require_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.9. 分页获取不受理列表
   */
  static getNotAcceptRequirePageList(params: {
    number?: string;
    deviceName?: string;
    reportErp?: string;
    stationBaseId?: number;
    vehicleAssemblyId?: number;
    isInfluenceOperation?: number;
    reportStartTime?: string;
    reportEndTime?: string;
    acceptUserErp?: string;
    serviceStationId?: number;
    pageNum: number;
    pageSize: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_can_not_accept_require_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.10. 获取维修单提报信息详情
   */
  static getRequireInfoGetReportDetail(params: {
    number: string;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/require_info_get_report_detail',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.11. 获取维修单提报人手机号
   */
  static getRequireReportPhone(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_require_report_phone',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.12. 受理维修单(旧)
   */
  static handleRequire(params: {
    number: string;
    isHandle: number;
    remark: string;
    isInfluenceOperation: any;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/handle_require',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.13. 获取车辆历史维修单列表
   */
  static getHistoryList(params: { deviceName: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_history_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.14. 获取维修单操作日志
   */
  static getRequireLogList(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_require_log_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.15. 获取维修单操作记录详情
   */
  static getRequireLogInfo(params: { requireLogId: number }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_require_log_info',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.16. 获取维修结果+费用明细+更换配件记录接口
   */
  static getAcceptRequireInfoDetail(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_accept_require_info_detail',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.17. 获取维修单可见权限详情
   */
  static getVisibleDetails(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_visible_details',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.18. 设置维修单可见权限
   */
  static setVisibleDetails(params: {
    number: string;
    type: string;
    oemVisible: number;
    serviceStationId: number;
    serviceStationVisible: number;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/set_visible_details',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.19. 获取维修单评论详情
   */
  static getRequireCommentList(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_require_comment_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.20. 发表评论
   */
  static sendComment(params: {
    number: string;
    replyToCommentId: number | undefined;
    content: string;
    attachment: { type: string; fileKey: string; bucketName: string }[];
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/post_comment',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.21. 获取车厂/服务站/京东提报人售后组人员列表
   */
  static getNotifyUserList(params: {
    number: string;
    type: string;
    serviceStationId?: string;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/get_notify_user_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.22. 发送通知
   */
  static sendNotify(params: {
    oemUserNameList: string[];
    serviceStationUserNameList: string[];
    vehicleReportUserName: string;
    number: string;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/send_notify',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.23. 维修完成/暂存
   */
  static completeRequire(params: {
    isSubmit: number;
    number: string;
    source: string;
    requireHardwareTypeIds: number[];
    maintenanceResultRemark: string;
    needAccessory: number;
    accessoryOrderNo: string;
    needOldPart: string;
    oldPartOrderNo: string;
    laborCostList: {
      serviceProject: string;
      cost: number;
      costType: string;
      remark: string;
    }[];
    serviceCostList: {
      serviceProject: string;
      cost: number;
      costType: string;
      remark: string;
    }[];
    otherCostList: {
      serviceProject: string;
      cost: number;
      costType: string;
      remark: string;
    }[];
    requireHardwareModelInfoList: {
      oldHardwareModelId: number;
      newHardwareModelId: number;
      newHardwareModelNumber: string;
      newHardwareModelCount: number;
      newHardwareModelCost: number;
      costType: string;
      remark: string;
    }[];
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/complete_require',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.24. 智驾小助手总结评论
   */
  static commentSummaryRequest(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/comment_summary_request',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 1.25. 智驾小助手获取回复
   */
  static commentSummaryResponse(params: {
    number: string;
    traceId: string;
    reqId: string;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/comment_summary_response',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }
  static getHardwareModel(params: { deviceName: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/device/get_hardware_model_of_device',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }
  static getHardwareType(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/hardware_type/get_hardware_type_list',
      method: 'POST',
      body: { enable: 1 },
    };
    return request(requestOptions);
  }
  static getHardwareModelType(id): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/hardware_type/get_hardware_model_of_type',
      method: 'POST',
      body: { hardwareTypeId: id },
    };
    return request(requestOptions);
  }
  static getDeviceVersionList(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/monitor/web/jira/get_rover_list',
      method: 'POST',
    };
    return request(requestOptions);
  }

  static createIssue(params: any): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/create_bug_of_require',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }
}
